import {Box, Typography} from "@mui/material";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {IconDefinition} from "@fortawesome/pro-duotone-svg-icons";

interface JournalMetricProps {
    icon: IconDefinition;
    label: string;
    value: string | number;
}

const JournalMetric = ({icon, label, value}: JournalMetricProps) => (
    <Box sx={{display: 'flex', alignItems: 'center', gap: .3, width: '100%',}}>
        <FontAwesomeIcon icon={icon}/>
        <Box sx={{display: 'flex', justifyContent: 'space-between', width: '100%'}}>
            <Typography sx={{fontSize: '0.8rem', fontWeight: 'bold'}}>
                {label}:
            </Typography>
            <Typography component="span" sx={{color: '#a6885a', fontSize: '1rem', fontWeight: 'bold'}}>
                {value}
            </Typography>
        </Box>
    </Box>
);

export default JournalMetric;
